import { Grid, Snackbar, Typography } from "@mui/material";
import axios from 'axios';
import { useState } from "react";
export default function Support() {

    var url = 'http://localhost:1000/'

    const [snack, setsnack] = useState(false);
    const [msg, setmsg] = useState('');
    function contactSupport(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);
        // var 
        var reason = data.get('reason');
        var fname = data.get('fname');
        var email = data.get('email');
        var mobile = data.get('mobile');
        var description = data.get('description');

        axios.post(url + 'contactSupport', {
            Name: fname,
            Email: email,
            Mobile: mobile,
            Reason: reason,
            Description: description
        }).then((succ) => {
            setsnack(true);
            setmsg(succ.data.reason);
            e.target.reset();
            e.target.reason.focus();
        })

    }


    return (
        <>

            <Grid container className='signinbackground' justifyContent={'center'} alignItems={'center'} height={'100vh'}>

                <Grid size={{ lg: 8 }} container bgcolor={'white'} borderRadius={2} minHeight={'40vh'}>
                    <Grid size={{ lg: 6 }} className='p-4'>
                        <Typography variant="h4">Contact Us</Typography>
                        <form className="mt-4" onSubmit={contactSupport}>
                            <select name="reason" className="form-select">
                                <option value={'App is not working'}>App is not working</option>
                                <option value={'i want to share a feedback or suggestion'}>i want to share a feedback or suggestion</option>
                                <option value={'Other'}>Other</option>
                            </select>
                            <input type="text" name="fname" className="form-control py-2 mt-3" placeholder="Full Name" />
                            <input type="text" name="email" className="form-control py-2 mt-3" placeholder="Email Address" />
                            <input type="text" name="mobile" className="form-control py-2 mt-3" placeholder="Mobile Number" />
                            <textarea rows={3} name="description" className="form-control resize-none mt-3" placeholder="Description"></textarea>
                            <button type="submit" className="btn-admin-navy py-2 mt-3">Log in</button>
                        </form>
                    </Grid>
                    <Grid size={{ lg: 6 }} borderLeft={'1px solid black'}>
                    </Grid>
                    <Snackbar open={snack} message={msg} autoHideDuration={3000} />
                </Grid>
            </Grid>


        </>
    )

}